import { useDispatch } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import { useCallback } from 'react';
import { reportMedia } from '../../store/reducers/media.reducer';

export const useReportMedia = () => {
    const dispatch = useDispatch();
    const { keycloak } = useKeycloak();

    const handleReportMedia = useCallback((mediaPoint, reason) => {
        if (!keycloak.token || !mediaPoint || !reason) {
            console.error("Cannot report: not authenticated, no media point, or no reason provided.");
            return;
        }
        dispatch(reportMedia({ mediaId: mediaPoint.id, reason, token: keycloak.token }));
    }, [dispatch, keycloak.token]);

    return { handleReportMedia };
};